// extracted by mini-css-extract-plugin
export default {"wrapper":"zkqJrE7PwCKIccjptXBD","title":"QouDZJWsHu3jY0pQXu4Z","list":"Jvvy1oZ4_dOzIBjJ0ZHL","variable":"sqqk4gsIXky9l88S6Uwg"};